export const statuses = {
  operational: {
    message: "All Systems Operational",
    backgroundColor: "rgb(61, 167, 81)",
  },
  outage: {
    message: "Some systems are experiencing problems",
  },
  no_information: {
    message: "No information available",
    backgroundColor: "rgb(235,76,67)",
  }
};
